import React from 'react'
import axios from 'axios'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, List, ListItem, ListItemIcon, ListItemText, Typography
} from '@material-ui/core'
import { CheckCircle, Warning as WarningIcon } from '@material-ui/icons'

const SubmissionReadinessModal = ({ open, projectId, url, onClose, onSubmitted }) => {
  const [loading, setLoading] = React.useState(false)
  const [items, setItems] = React.useState([])
  const [ready, setReady] = React.useState(false)
  const [submitting, setSubmitting] = React.useState(false)

  React.useEffect(() => {
    if (open && projectId) {
      setLoading(true)
      axios.get(`${url}/api/bid-estimation/projects/${projectId}/submission-readiness`).then(res => {
        setItems(res.data.items || [])
        setReady(res.data.ready || false)
        setLoading(false)
      }).catch(err => {
        console.error('Failed to fetch readiness:', err)
        setLoading(false)
      })
    }
  }, [open, projectId])

  const handleSubmit = () => {
    setSubmitting(true)
    axios.put(`${url}/api/bid-estimation/projects/${projectId}`, {
      status: 'submitted',
      'followUp.submittedAt': new Date().toISOString()
    }).then(() => {
      setSubmitting(false)
      onSubmitted()
    }).catch(err => {
      setSubmitting(false)
      console.error('Submit failed:', err)
    })
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Submit Estimate — Readiness Check</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <List dense>
              {items.map(item => (
                <ListItem key={item.key} style={{ paddingLeft: 0 }}>
                  <ListItemIcon style={{ minWidth: 32 }}>
                    {item.pass
                      ? <CheckCircle style={{ color: '#4caf50', fontSize: 20 }} />
                      : <WarningIcon style={{ color: '#ff9800', fontSize: 20 }} />
                    }
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    secondary={item.detail || undefined}
                    primaryTypographyProps={{ variant: 'body2' }}
                    secondaryTypographyProps={{ variant: 'caption', style: { color: '#e65100' } }}
                  />
                </ListItem>
              ))}
            </List>
            {ready && (
              <Typography variant="body2" style={{ color: '#2e7d32', marginTop: 8 }}>
                All checks passed. Ready to submit.
              </Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        {!ready && !loading && (
          <Button onClick={handleSubmit} disabled={submitting} variant="outlined"
            style={{ textTransform: 'none' }}>
            {submitting ? <CircularProgress size={16} /> : 'Submit Anyway'}
          </Button>
        )}
        {ready && !loading && (
          <Button onClick={handleSubmit} disabled={submitting} color="primary" variant="contained"
            style={{ textTransform: 'none' }}>
            {submitting ? <CircularProgress size={16} /> : 'Submit Estimate'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default SubmissionReadinessModal
